// extracted by mini-css-extract-plugin
export default {"container":"ProfileInfo_container__bqs1W","benefits":"ProfileInfo_benefits__-a+Qf","rightColumn":"ProfileInfo_rightColumn__mDS2Y","name":"ProfileInfo_name__Wr8QA"};